export function scrubProspectInviteTokens<T extends object>(value: T) {
	scrubStrings(value);
	return value;
}

function scrubStrings(value: object) {
	for (const [key, item] of Object.entries(value)) {
		const scrubbedKey = scrubText(key);
		if (scrubbedKey !== key) {
			Reflect.deleteProperty(value, key);
			Reflect.set(value, scrubbedKey, item);
		}
		if (typeof item === "string")
			Reflect.set(value, scrubbedKey, scrubText(item));
		else if (key !== "sdkProcessingMetadata" && isPlainData(item))
			scrubStrings(item);
	}
}

function isPlainData(value: unknown): value is object {
	if (typeof value !== "object" || value === null) return false;
	const prototype = Object.getPrototypeOf(value);
	return (
		Array.isArray(value) || prototype === Object.prototype || prototype === null
	);
}

function scrubText(text: string) {
	return text
		.replace(/(prospect-invite(?:\/|%(?:25)*2F))[0-9a-f]{64}/gi, "$1:token")
		.replace(/(__clerk_ticket(?:=|%(?:25)*3D))[\w.-]+/gi, "$1[Filtered]")
		.replace(/(\btoken\\?"\s*:\s*\\?")[0-9a-f]{64}/gi, "$1[Filtered]");
}
